// Application layer - pagar factura
import { insertarFactura } from "../infrastructure/supabase/supabaseFactura.js";
import { insertarVenta } from "../infrastructure/supabase/supabaseVentas.js";
import { insertarDetalleVenta } from "../infrastructure/supabase/supabaseDetalle.js";

import { construirVenta } from "../domain/entities/Venta.js";
import { construirDetalle } from "../domain/entities/DetalleVenta.js";

import { registrarSalidaInventarioUseCase } from "../../inventarios/application/registrarSalidaInventario.usecase.js";

/**
 * Caso de uso: pagar factura
 * ------------------------------------------------
 * Responsabilidad:
 * - Guardar factura en BD
 * - Guardar ventas y detalles
 * - Registrar salida de inventario
 */
export async function pagarFacturaUseCase({ factura, metodoPago }) {
  if (!factura) throw new Error("Factura inválida");
  if (!metodoPago) throw new Error("Método de pago requerido");

  // Estado para control de flujo y logs
  const estadoProceso = {
    etapa: "inicio",
    idFactura: null,
    idVenta: null,
    productoId: null,
  };

  try {
    estadoProceso.etapa = "insertarFactura";
    const facturaBD = await insertarFactura({ ...factura, estado: "pagada" });
    const idFactura = facturaBD?.data?.[0]?.id || facturaBD?.idFactura;
    if (!idFactura) throw new Error("No se generó ID de factura");
    estadoProceso.idFactura = idFactura;

    console.log("[pagarFacturaUseCase] Factura registrada con ID:", idFactura);

    for (const pedido of factura.pedidos || []) {
      estadoProceso.etapa = "insertarVenta";
      const venta = construirVenta({
        mesaId: pedido.mesaId,
        total: pedido.total,
        metodoPago,
      });
         // venta 
      const ventaBD = await insertarVenta({ id_factura: idFactura, venta });
      const idVenta = ventaBD?.data?.[0]?.id_venta || ventaBD?.id_venta;
      if (!idVenta) throw new Error("No se generó ID de venta");
      estadoProceso.idVenta = idVenta;

      console.log("[pagarFacturaUseCase] Venta registrada con ID:", idVenta);

      for (const producto of pedido.productos || []) {
        estadoProceso.etapa = "insertarDetalle";
        estadoProceso.productoId = producto.id_producto;
          // detalle 
        const detalle = construirDetalle({ producto });
        await insertarDetalleVenta({ id_venta: idVenta, detalle });
        console.log(
          "[pagarFacturaUseCase] Detalle registrado para producto:",
          detalle.id_producto,
        );

        estadoProceso.etapa = "registrarInventario";
        await registrarSalidaInventarioUseCase({
          idProducto: detalle.id_producto,
          cantidad: detalle.cantidad,
          idReferencia: idVenta,
          origen: "Venta",
          tipoMovimiento: "salida",
        });
        console.log(
          "[pagarFacturaUseCase] Inventario actualizado para producto:",
          detalle.id_producto,
        );
      }
    }

    console.log("[pagarFacturaUseCase] Factura pagada correctamente:", {
      idFactura,
    });
    return { idFactura, estado: "pagada" };
  } catch (error) {
    console.error(
      "[pagarFacturaUseCase] Error en etapa:",
      estadoProceso.etapa,
      {
        idFactura: estadoProceso.idFactura,
        idVenta: estadoProceso.idVenta,
        productoId: estadoProceso.productoId,
        mensaje: error.message,
      },
    );

    // Devuelves info útil para debug o rollback
    throw new Error(
      `Error en pago de factura en etapa "${estadoProceso.etapa}": ${error.message}`,
    );
  }
}
